<div class="app-version-form">
    <div class="form-field">
        <label>{{'version_name'| translation}}</label>
        <input pInputText [placeholder]="'version_name'| translation" [(ngModel)]="version.name" fluid />
    </div>
    <label>{{'version_details'| translation}}</label>
    <editor [init]="editor_options" ngDefaultControl [(ngModel)]="version.description"></editor>

</div>